// extracted by mini-css-extract-plugin
module.exports = {"module":"SimpleCard_module__3YCyo","inner":"SimpleCard_inner__c7Hii","positionCenter":"SimpleCard_positionCenter__3FNVo","positionTop":"SimpleCard_positionTop__Tlk8t"};